module.exports = __webpack_public_path__ + "img/EFFA-JMC.8b661031.svg";